import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as getTime from '~/skills/getTime';
import * as getStatus from '~/skills/getStatus';
import Actions from '~/Actions';
import Actions_Wind from '~/Actions_Wind';
import PageTitle from '~/components/PageTitle';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Date, EAA_Memo, EAA_Input, EAA_ErrorText, EAA_Status, EAA_UpdateTime, EAA_BottomBtn } from '~/components/EditAndAddItem';
import BoatAdminTree from '~/components/BoatAdminTree';
import Sub1 from './Sub1';

const modeInfo = {
  add: {
    title: '本國船舶新增',
  },
  edit: {
    title: '本國船舶編輯',
  },
  view: {
    title: '本國船舶檢視',
  },
};

class AddAndEdit extends Component {
  state={ data: {}, old_data: {}, mode: '', canSend: true, errorAry: [] }
  componentDidMount () {
    const { id, getNativeBoatIdDetail, mode = '', setPageText } = this.props;
    setPageText(modeInfo[mode].title);
    if (mode !== 'add')getNativeBoatIdDetail(id);
  }

  componentDidUpdate (preProps) {
    const { NativeBoatIdDetail: preNativeBoatIdDetail = {} } = preProps;
    const { NativeBoatIdDetail = {}, mode } = this.props;
    if (Object.keys(preNativeBoatIdDetail).length === 0 && Object.keys(NativeBoatIdDetail).length > 0 && (mode !== 'add')) {
      this.setState({ data: NativeBoatIdDetail, old_data: NativeBoatIdDetail });
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('NativeBoatIdDetail');
    clearKey('PageText');
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  getSendBody=() => {
    const { data } = this.state;
    const body = {
      ship_name: data.ship_name || '',
      imo: data.imo || '',
      shipowner: data.shipowner || '',
      ship_stage: data.ship_stage || '',
      note: data.note || '',
      actual_op_check: data.actual_op_check || '',
      actual_start_date: (data.actual_op_check === '1') ? data.actual_start_date : '',
      actual_end_date: (data.actual_op_check === '1') ? data.actual_end_date : '',
      sub1: data.sub1 || [],
      exec_job: data.exec_job || [],

      windcontract_id: Actions_Wind.wind_id(),
    };
    return body;
  }

  add=(status = {}) => {
    this.setState({ canSend: false });
    const body = { ...this.getSendBody(), ...status };
    this.props.postAddNewNativeBoat(body);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=(status = {}) => {
    this.setState({ canSend: false });
    const { id, putNativeBoatIdDetail } = this.props;
    const body = { ...this.getSendBody(), ...status };
    putNativeBoatIdDetail(id, body);
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(data.ship_name) === '', // 0 船舶名稱
      returnInputValue(data.imo) === '', // 1 imo
      returnInputValue(data.shipowner) === '', // 2 船東
      returnInputValue(data.ship_stage) === '', // 3 階段
      returnInputValue(data.actual_op_check) === '', // 4 實際作業確認
      (data.actual_op_check === '1') && (returnInputValue(data.actual_start_date) === ''), // 5 實際船期 - 開始
      (data.actual_op_check === '1') && (returnInputValue(data.actual_end_date) === ''), // 6 實際船期 - 結束
      (data.actual_op_check === '1') && (returnInputValue(data.actual_start_date) !== '') && (returnInputValue(data.actual_end_date) !== '') && (getTime.returnDate(data.actual_start_date) > getTime.returnDate(data.actual_end_date)), // 7 『實際船期 - 開始』 大於 『實際船期 - 結束』
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  render () {
    const { mode = '', BoatStageList = [] } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry } = this.state;
    const isCheck = this.state.mode === 'check';
    const disabled = mode === 'view' || isCheck || (!getStatus.canEdit(data));
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const allRight = errorAry.indexOf(true) === -1;
    const titleWidth = 120;
    const errorLeft = titleWidth + 20;

    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text={modeInfo[mode].title} />
        <div style={{ height: 8 }} />

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='船舶名稱' bol={true} haveChange={checkChange('ship_name')} />
              <EAA_Input displayBorder disabled={disabled} hint='詳答' value={returnInputValue(data.ship_name)} onChange={data => { this.changeData({ label: 'ship_name', data }); }} />
            </EAA_ItemContainer>
            {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='IMO' bol={true} haveChange={checkChange('imo')} />
              <EAA_Input displayBorder disabled={disabled} hint='詳答' value={returnInputValue(data.imo)} onChange={data => { this.changeData({ label: 'imo', data }); }} />
            </EAA_ItemContainer>
            {errorAry[1] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='船東' bol={true} haveChange={checkChange('shipowner')} />
              <EAA_Input displayBorder disabled={disabled} hint='全名' value={returnInputValue(data.shipowner)} onChange={data => { this.changeData({ label: 'shipowner', data }); }} />
            </EAA_ItemContainer>
            {errorAry[2] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='階段' bol={true} haveChange={checkChange('ship_stage')} />
              <EAA_Select displayBorder disabled={disabled} list={BoatStageList} value={returnInputValue(data.ship_stage)} onChange={data => { this.changeData({ label: 'ship_stage', data }); }} />
            </EAA_ItemContainer>
            {errorAry[3] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='執行作業' bol={true} haveChange={isCheck && (JSON.stringify(data.exec_job || []) !== JSON.stringify(old_data.exec_job || []))} />
              <BoatAdminTree value={data.exec_job || []} onChange={data => this.changeData({ label: 'exec_job', data }) } {...{ disabled }} />
            </EAA_ItemContainer>
            {/* {errorAry[0] && <EAA_ErrorText  marginLeft={errorLeft} text='帳號需為 1 ~ 100 英數字。' />} */}
          </EAA_Item>
        </EAA_Row>

        <Sub1 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} />

        <EAA_Row>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
            <EAA_TitleText width={titleWidth} text='備註' haveChange={checkChange('note')} />
            <EAA_Memo displayBorder disabled={disabled} value={returnInputValue(data.note)} onChange={data => this.changeData({ label: 'note', data })} />
          </div>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='實際作業確認' bol={true} haveChange={checkChange('actual_op_check')} />
              <CircleCheckBox disabled={disabled} value={data.actual_op_check === '1'} onClick={() => this.changeData({ label: 'actual_op_check', data: '1' })} />
              <div style={{ marginLeft: 4, marginRight: 8 }}>有</div>
              <CircleCheckBox disabled={disabled} value={data.actual_op_check === '0'} onClick={() => this.changeData({ label: 'actual_op_check', data: '0' })} />
              <div style={{ marginLeft: 4 }}>無</div>
              {(returnInputValue(data.actual_op_check) === '') && <div style={{ marginLeft: 8, color: 'red' }}>{'請確認"該船舶"(代入申請船舶名稱)是否實際進行作業?'}</div>}
            </EAA_ItemContainer>
            {errorAry[4] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
          </EAA_Item>
        </EAA_Row>

        {data.actual_op_check === '1' && (
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='實際船期' bol={true} haveChange={checkChange('gggactual_start_dategg') || checkChange('actual_end_date')} />
                <EAA_Date displayBorder disabled={disabled} hint='開始日期' value={getTime.returnDate(data.actual_start_date)} onChange={data => this.changeData({ label: 'actual_start_date', data: getTime.getType3Time(data) })} marginRight={8} />
                <EAA_Date displayBorder disabled={disabled} hint='結束日期' value={getTime.returnDate(data.actual_end_date)} onChange={data => this.changeData({ label: 'actual_end_date', data: getTime.getType3Time(data) })} marginRight={8} />
              </EAA_ItemContainer>
              {errorAry[5] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇開始日期' />}
              {errorAry[6] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇結束日期' />}
              {errorAry[7] && <EAA_ErrorText marginLeft={errorLeft} text='『開始日期』不可晚於『結束日期』' />}
            </EAA_Item>
          </EAA_Row>
        )}

        <div style={{ height: 16 }} />

        <EAA_Status data={data} />
        <EAA_UpdateTime data={data} />

        <EAA_BottomBtn
          {...{
            data,
            mode,
            isCheck,
            allRight,
            canSend,
            onClose: this._onClose,
            goToCheck: this.goToCheck,
            goToEdit: this.goToEdit,
            add: this.add,
            edit: this.edit,
          }}
        />

        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewNativeBoat' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutNativeBoatIdDetail' />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  NativeBoatIdDetail: state.data.NativeBoatIdDetail,
  BoatStageList: state.data.BoatStageList,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
  setPageText: text => Actions.setPageText(dispatch, { text }),
  getNativeBoatIdDetail: id => Actions_Wind.getNativeBoatIdDetail(dispatch, { id }),
  postAddNewNativeBoat: body => Actions_Wind.postAddNewNativeBoat(dispatch, { body }),
  putNativeBoatIdDetail: (id, body) => Actions_Wind.putNativeBoatIdDetail(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
